<template>
  <footer class="footer">
    <div class="columns is-multiline is-vcentered">
      <div class="column is-8-desktop is-offset-2-desktop is-12-tablet">
        <p class="has-text-centered">
          <small>
            Készült az EFOP-1.8.0_VEKOP-17-2017-00001 azonosítószámú projekt keretében.
            Projekt címe: Egészségügyi ellátórendszer szakmai módszertani fejlesztése.
            A projekt a Széchenyi 2020 program keretében valósul meg. <br>
            Adatait a Semmelweis Egyetem Adatvédelmi Szabályzatában foglaltaknak megfelelően kezeljük, melyet <a href="http://semmelweis.hu/jogigfoig/dokumentumtar/szabalyzattar/adatvedelmi-szabalyzat/" target="_blank">ezen a linken olvashat el.</a>
          </small>
        </p>
        <br>
      </div>
      <div class="column is-4-desktop is-offset-2-desktop is-5-tablet is-offset-1-tablet is-6-mobile is-offset-3-mobile">
        <ProjectLogos></ProjectLogos>
      </div>
      <div class="column is-4-desktop is-5-tablet is-6-mobile is-offset-3-mobile">
        <Impressum></Impressum>
      </div>
    </div>
  </footer>
</template>

<script>
  import ProjectLogos from '@/components/General/ProjectLogos'
  import Impressum from '@/components/General/Impressum'

  export default {
    data () {
      return {
        currentYear: new Date().getFullYear()
      }
    },
    components: {
      ProjectLogos,
      Impressum
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/General/Footer.vue